﻿import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const AptitudesTableBody = ({ aptitudes, handleDelete, groupAptitudes, setGroupAptitudes }) => {
	const navigate = useNavigate();

	const selectAptitude = (aptitud) => {
		let newAptitude = [...groupAptitudes];
		if (!newAptitude.find((a) => Number(a.id) === Number(aptitud.id))) {
			newAptitude.push(aptitud);
		} else {
			newAptitude = newAptitude.filter((a) => Number(a.id) !== Number(aptitud.id));
		}

		setGroupAptitudes(newAptitude);
	};

	return (
		<tbody>
			{aptitudes &&
				aptitudes.map((item, i) => {
					let checked = false;
					if (groupAptitudes.find((a) => Number(a.id) === Number(item.id))) {
						checked = true;
					}

					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td}`}>
								<div
									className={`${classes.table_div} ${classes.center}`}
									style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}
								>
									<Form.Check type="checkbox" checked={checked} onChange={(_e) => selectAptitude(item)} />
									{groupAptitudes[0] && groupAptitudes[0].id === item.id && (
										<span className="badge badge-info" style={{ fontSize: "8px" }}>
											1er elemento
										</span>
									)}
								</div>
							</td>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									<PencilSvg className={classes.icon} onClick={() => navigate("/mantenedores/aptitudes/editar/" + item.id)} />
									<RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default AptitudesTableBody;
